module.exports = __webpack_public_path__ + "static/media/shawarma_frango.83f19e67.jpg";